import { toString } from 'hast-util-to-string';
import { visit } from 'unist-util-visit';

const languagePrefix = "language-";
function rehypeShikiFromHighlighter(highlighter, options) {
  const langs = highlighter.getLoadedLanguages();
  const {
    addLanguageClass = false,
    parseMetaString,
    cache,
    defaultLanguage,
    fallbackLanguage,
    onError,
    ...rest
  } = options;
  return function(tree) {
    visit(tree, "element", (node, index, parent) => {
      if (!parent || index == null || node.tagName !== "pre")
        return;
      const head = node.children[0];
      if (!head || head.type !== "element" || head.tagName !== "code" || !head.properties) {
        return;
      }
      const classes = head.properties.className;
      const languageClass = Array.isArray(classes) ? classes.find(
        (d) => typeof d === "string" && d.startsWith(languagePrefix)
      ) : void 0;
      let lang = typeof languageClass === "string" ? languageClass.slice(languagePrefix.length) : defaultLanguage;
      if (!lang)
        return;
      if (fallbackLanguage && !langs.includes(lang))
        lang = fallbackLanguage;
      const code = toString(head);
      const cachedValue = cache?.get(code);
      if (cachedValue) {
        parent.children.splice(index, 1, ...cachedValue);
        return;
      }
      const metaString = head.data?.meta ?? head.properties.metastring?.toString() ?? "";
      const meta = parseMetaString?.(metaString, node, tree) || {};
      const codeOptions = {
        ...rest,
        lang,
        meta: {
          ...rest.meta,
          ...meta,
          __raw: metaString
        }
      };
      if (addLanguageClass) {
        codeOptions.transformers || (codeOptions.transformers = []);
        codeOptions.transformers.push({
          name: "rehype-shiki:code-language-class",
          code(node2) {
            this.addClassToHast(node2, `${languagePrefix}${lang}`);
            return node2;
          }
        });
      }
      try {
        const fragment = highlighter.codeToHast(code, codeOptions);
        cache?.set(code, fragment.children);
        parent.children.splice(index, 1, ...fragment.children);
      } catch (error) {
        if (onError)
          onError(error);
        else
          throw error;
      }
    });
  };
}

export { rehypeShikiFromHighlighter as default };
